module.exports = __webpack_public_path__ + "static/media/lateralhead_normal.a2deeeac.png";